<template>
  <div class="d-flex flex-wrap">
    <div
      v-for="(option, index) of info.extension_info.values"
      :key="option"
      class="col-3 m-2"
    >
      <CFormCheck
        type="radio"
        :id="`${info.part_item_id}${index}`"
        :label="option"
        :value="option"
        :disabled="+info.is_help"
        @change="emitContent(index)"
        :checked="index === optionId"
        required
        :name="info.part_item_id"
        :model-value="optionId"
      />
    </div>
    <div v-if="info.extension_info.last === '其他'" class="col-3 m-2">
      <CFormCheck
        type="radio"
        :id="`${info.part_item_id}${info.extension_info.values.length}`"
        label="其他"
        :value="-1"
        :disabled="+info.is_help"
        @change="emitContent(-1)"
        :checked="optionId === -1"
        required
        :name="info.part_item_id"
        :model-value="optionId"
      />
      <CFormInput
        class="col-12 mt-2"
        placeholder="請填寫其他內容"
        v-model="otherText"
        :disabled="(optionId !== -1)"
        @blur="emitContent(-1)"
      />
    </div>
  </div>
</template>
<script>
import { ref, watch, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const optionId = ref(null)
    const otherText = ref('')
    const emitContent = (id) => {
      if(id !== undefined){
        optionId.value = id
      }
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: !!String(optionId.value),
        value_info: +props.info.is_help === 0 ? {
          select: optionId.value,
          other_value: otherText.value,
        } : null,
      })
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newVal) => {
        if(newVal){
          otherText.value = newVal.other_value
          emitContent(newVal.select)
        }
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
      {immediate: true, deep: true}
    )
    return {
      optionId,
      emitContent,
      otherText,
    }
  },
}
</script>
